import {
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from '@mui/lab';
import { Avatar, Grid } from '@mui/material';
import { FaDotCircle, FaBriefcase } from 'react-icons/fa';
import {
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  WsColors,
  formatDayToTime,
  WsBadgetype,
  WsBadge,
  WsBadgeSize,
} from 'wisestep-base';

import {
  iconBg,
  separatorIcons,
} from '../../../features/candidateLayout/components/activityLogs/components/utils/helper';
interface JobActivityItemProps {
  index: number;
  activity: any;
  isLast?: boolean;
}

const JobActivityItem = ({ index, activity, isLast = false }: JobActivityItemProps) => {
  const actionType = activity.activityType ?? '';

  const renderJobActivityText = () => {
    const recruitersName = activity.modifiedBy ?? activity.recruiterName;
    const isModifiedBy = !activity.recruiterName;

    const RecruiterTypography = (
      <WsTypography
        display="inline"
        color={isModifiedBy ? WsTypoColors.PRIMARY600 : WsTypoColors.TERTIARY900}
        bold
      >
        {recruitersName}
      </WsTypography>
    );

    switch (activity.activityType) {
      case 'CREATED':
      case 'CLOSE_JOB':
        return (
          <>
            <WsTypography>
              {RecruiterTypography} has {activity.activityType === 'CREATED' ? 'created' : 'closed'}{' '}
              the job.
            </WsTypography>
            <Grid>
              Status :
              <WsBadge
                label={activity.activityType === 'CREATED' ? 'Open' : 'Closed'}
                badgeType={
                  activity.activityType === 'CREATED' ? WsBadgetype.SUCCESS : WsBadgetype.FAILED
                }
                icon={<FaBriefcase size={16} />}
                startIcon
                badgeSize={WsBadgeSize.LARGE}
              />
            </Grid>
          </>
        );

      case 'UPDATED':
        return <WsTypography>{RecruiterTypography} has updated the job details.</WsTypography>;

      case 'UNASSIGNED':
        return <WsTypography>{RecruiterTypography} has unassigned the job.</WsTypography>;

      case 'ACCEPTED':
        return <WsTypography>{RecruiterTypography} has accepted the job.</WsTypography>;

      case 'REOPEN_JOB':
        return (
          <>
            <WsTypography>{RecruiterTypography} has reopened the job.</WsTypography>
            <Grid>
              Status :
              <WsBadge
                label={'Open'}
                badgeType={WsBadgetype.SUCCESS}
                icon={<FaBriefcase size={16} />}
                startIcon
                badgeSize={WsBadgeSize.LARGE}
              />
            </Grid>
          </>
        );

      default:
        return <WsTypography>{RecruiterTypography} performed an action.</WsTypography>;
    }
  };

  return (
    <TimelineItem>
      <TimelineOppositeContent color="text.secondary" alignContent="center">
        {formatDayToTime(activity.createdOn)}
      </TimelineOppositeContent>

      <TimelineSeparator>
        {index === 0 && <FaDotCircle color={WsColors.GreyBlack} />}
        <TimelineConnector sx={{ height: 20 }} />
        <Avatar sx={{ bgcolor: iconBg[actionType] }}>{separatorIcons[actionType]}</Avatar>
        <TimelineConnector sx={{ height: 40 }} />
        {isLast && <FaDotCircle color={WsColors.GreyBlack} />}
      </TimelineSeparator>

      <TimelineContent alignContent="center">
        <Grid display="flex" flexDirection="column" ml={1} mt={-1}>
          <WsTypography variant={WsTypoVariants.BODY1}>{renderJobActivityText()}</WsTypography>
        </Grid>
      </TimelineContent>
    </TimelineItem>
  );
};

export default JobActivityItem;
